import StaticTemplateTabs from './StaticTemplateTabs';

export default StaticTemplateTabs;
